export default function TrustSection() {
  const features = [
    {
      icon: "ri-shield-check-line",
      label: "Links Verificados",
      img: "https://readdy.ai/api/search-image?query=Closeup%20photography%20of%20verified%20stamp%20on%20dark%20craft%20paper%20texture%2C%20warm%20gold%20wax%20seal%2C%20dramatic%20side%20lighting%2C%20luxury%20authentication%20concept%2C%20rich%20amber%20tones%2C%20editorial%20product%20photography&width=300&height=200&seq=trust-verify-v2&orientation=landscape",
    },
    {
      icon: "ri-fire-line",
      label: "Produtos Populares",
      img: "https://readdy.ai/api/search-image?query=Trending%20fashion%20items%20flat%20lay%20on%20dark%20slate%20surface%2C%20sunglasses%20watch%20and%20chain%20arrangement%2C%20warm%20accent%20lighting%20from%20above%2C%20editorial%20style%2C%20luxurious%20dark%20mood%2C%20rich%20contrast&width=300&height=200&seq=trust-popular-v2&orientation=landscape",
    },
    {
      icon: "ri-user-star-line",
      label: "Vendedores Confiáveis",
      img: "https://readdy.ai/api/search-image?query=Professional%20rating%20stars%20on%20textured%20charcoal%20background%2C%20five%20gold%20stars%20with%20warm%20glow%2C%20review%20concept%20photography%2C%20soft%20bokeh%20effect%2C%20trust%20and%20quality%20theme%2C%20elegant%20minimal%20composition&width=300&height=200&seq=trust-sellers-v2&orientation=landscape",
    },
    {
      icon: "ri-book-open-line",
      label: "Guias Completos",
      img: "https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20notes%20on%20dark%20wooden%20desk%2C%20pen%20and%20warm%20reading%20lamp%2C%20cozy%20study%20atmosphere%2C%20soft%20golden%20lighting%2C%20knowledge%20and%20learning%20concept%2C%20intimate%20editorial%20style&width=300&height=200&seq=trust-guides-v2&orientation=landscape",
    },
    {
      icon: "ri-refresh-line",
      label: "Atualizações Semanais",
      img: "https://readdy.ai/api/search-image?query=Calendar%20with%20marked%20dates%20on%20dark%20minimal%20desk%20setup%2C%20warm%20coffee%20beside%20planner%2C%20soft%20morning%20light%20through%20window%2C%20fresh%20start%20concept%2C%20organized%20workspace%2C%20clean%20editorial%20photography&width=300&height=200&seq=trust-updates-v2&orientation=landscape",
    },
  ];

  const testimonials = [
    {
      name: "Lucas Oliveira",
      handle: "@lucas_sneakers",
      text: "A melhor Hoobuy Spreadsheet que já usei. Links sempre atualizados e vendedores confiáveis. Economizei muito tempo.",
    },
    {
      name: "Marina Costa",
      handle: "@marinafinds",
      text: "Finalmente uma planilha Hoobuy em português! As categorias são super organizadas e encontrei produtos incríveis.",
    },
    {
      name: "Pedro Santos",
      handle: "@pedro_street",
      text: "Uso toda semana para comprar streetwear. Os links da Hoobuy Spreadsheet são verificados e sempre funcionam.",
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Confiável
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
            Por Que Escolher Nossa<br />
            Hoobuy Spreadsheet?
          </h2>
        </div>

        {/* Features with Images */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-5 mb-14">
          {features.map((item) => (
            <div
              key={item.label}
              className="flex flex-col rounded-xl bg-background-50 border border-background-200/60 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.label}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className={`${item.icon} text-base`}></i>
                </div>
                <span className="text-xs md:text-sm font-semibold text-foreground-800">{item.label}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div
              key={t.handle}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary-300 to-accent-300 flex items-center justify-center text-white font-bold text-sm">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.handle}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed italic">
                &ldquo;{t.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}